import { ReactNode } from 'react';

import { isSSG } from 'modules/common/utils/isSSG';

import { ChainsListPageTitle } from '../ChainsListPageTitle';
import { ChainsSkeleton } from '../ChainsSkeleton';

interface BaseChainsProps {
  top?: ReactNode;
  loading: boolean;
  children: ReactNode;
}

export const BaseChains = ({ children, loading, top }: BaseChainsProps) => {
  return (
    <>
      {top}
      <ChainsListPageTitle />
      {loading && !isSSG() ? <ChainsSkeleton /> : <>{children}</>}
    </>
  );
};
